<template>
    <div class="card" style="min-height: 450px;">
        <h6 class="card-header text-primary">Beneficiary Profile</h6>
        <div class="card-body">
            <section class="col-md-12">
                <h6 class="row font-weight-bold">BENEFICIARY BIO DATA</h6>
                <!-- Beneficiary detials section -->
                <form action="#" @submit.prevent >
                    <div class="row justify-content-center mt-4">
                        <div class="col-md-4 form-group mb-3">
                            <label><span class="text-danger">*</span>Beneficiary Name</label>
                            <input class="form-control form-control-sm" type="text" placeholder="Enter Beneficiary Name" v-model.trim="$v.formAccount.name.$model">
                        </div>

                        <div class="col-md-4 form-group mb-3">
                            <label><span class="text-danger">*</span>Beneficiary Email</label>
                            <input class="form-control form-control-sm" type="email" placeholder="Enter Beneficiary Email" v-model.trim="$v.formAccount.email.$model"  :class="{'is-invalid':$v.formAccount.email.$error}">
                        </div>
                    </div>
                    <div class="row justify-content-center mt-4">
                        <div class="col-md-4 form-group mb-3">
                            <label><span class="text-danger">*</span>Beneficiary Phone Number</label>
                            <input class="form-control form-control-sm" type="text"  placeholder="Enter Beneficiary phone" v-model.trim="$v.formAccount.phone.$model"  :class="{'is-invalid':$v.formAccount.phone.$error}">
                        </div>

                        <div class="col-md-4 form-group mb-3">
                            <label><span class="text-danger">*</span>Account Status</label>
                            <select name="accountStatus" id="accountStatus" class="form-control form-control-sm" placeholder="Enter Beneficiary Email" v-model.trim="$v.formAccount.accountStatus.$model"  :class="{'is-invalid':$v.formAccount.accountStatus.$error}">
                                <option value="1">Active</option>
                                <option value="0">In-active</option>
                            </select>
                        </div>
                    </div>
                    <div class="row justify-content-center form-group mb-5 mt-3">
                        <!--TODO change the updating back to false when implemented-->
                        <button v-if="updating" class="btn btn-primary btn-sm col-md-4" :disabled="$v.formAccount.$invalid" type="submit" @click.prevent="updateAccount()">Update Beneficiary Account </button>
                        
                        <button v-else class="btn btn-primary btn-sm col-md-4" disabled type="submit" > Update Beneficiary Account </button>
                    </div>
                </form>
            </section>

            <hr>

            <section class="row justify-content-between px-4 mt-5">
                <!-- Beneficiary setup income profile -->
                <form action="#" v-if="createIncome" @submit.prevent class="col-md-5">
                    <h6 class="row border-bottom pb-1 font-weight-bold">ADD INCOME PROFILE</h6>

                    <!-- 1st form group -->
                    <div v-if="!showNextForms">
                        <div class="row form-group mb-3 px-2">
                            <label for="itemCode"><span class="text-danger">*</span>Select an Item</label>
                            <multiselect v-model="itemHolder"  :options="everyItems" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="select an item" label="itemName" track-by="itemCode" :preselect-first="false">
                            </multiselect>
                        </div>

                        <div class="row form-group mb-3 px-2">
                            <label for="stateCode"><span class="text-danger">*</span>Select States</label>
                            <multiselect v-model="statesHolder" :options="enrolledStates" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="select states" label="stateName" track-by="stateCode" :preselect-first="false">
                            </multiselect>
                        </div>

                        <div class="row form-group mb-3 px-2 mt-5">
                            <button :disabled="!statesHolder.length || !itemHolder" class="btn btn-primary btn-sm w-100" @click="nextSetProfile" type="submit"> Next </button>
                        </div>
                    </div>

                    <!-- 2nd Form group -->
                    <div v-else>
                        <div class="my-2 font-weight-bold">Item Name: {{itemHolder.itemName}}</div>
                        <div class="row justify-content-center">
                            <div class="col-md-4 font-weight-bold">
                                State
                            </div>
                            <div class="col-md-5 font-weight-bold">
                                Settlement Type
                            </div>
                            <div class="col-md-3 font-weight-bold">
                                Settlement Value
                            </div>
                        </div>

                        <div v-for="(state, i) in setupArray" :key="i" class="row justify-content-center mb-3">
                            <div class="col-md-4 form-control form-control-sm">
                                {{state.stateName}}
                            </div>
                            <div class="col-md-5">
                                <select class="form-control form-control-sm" placeholder="Select type" v-model="state.settlementType">
                                    <option value="" selected>- choose settlement type -</option>
                                    <!-- <option value="fixed">Fixed</option> -->
                                    <option value="percent">Percentage</option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                <input class="form-control form-control-sm" type="number" step="0.1"  min="0" placeholder="0" v-model="state.settlementValue" >
                            </div>
                        </div>

                        <div class="row justify-content-between mb-3 px-2 mt-5">
                            <div>
                                <button class="btn btn-danger btn-sm px-5" type="submit" @click="showNextForms = false"> Back </button>
                                
                            </div>
                            <div class="">
                                <button v-if="!sending" class="btn btn-primary btn-sm px-5" type="submit" @click="showCreateModal()"> Create Income Profile </button>
                                
                                <button v-else class="btn btn-primary btn-sm" disabled type="submit" > Create Income Profile </button>
                            </div>
                        </div>
                    </div>
                </form>
                
                <!-- Beneficiary update income profile -->
                <form action="#" v-else @submit.prevent class="col-md-5">
                    <h6 class="row border-bottom pb-1 font-weight-bold">UPDATE INCOME PROFILE</h6>

                    <input type="hidden" name="incProfileId" v-model="incProfileId">

                    <div class="row form-group mb-3 px-2">
                        <label for="stateCode">State</label>
                        <p class="form-control mb-0 bg-light">{{formProfile.stateCode}}</p>
                    </div>

                    <div class="row form-group mb-3 px-2">
                        <label for="itemCode">Item</label>
                        <p class="form-control mb-0 bg-light">{{formProfile.itemCode}}</p>
                    </div>

                    <div class="row form-group mb-3 px-2">
                        <label for="settlementType"><span class="text-danger">*</span>Settlement Type</label>
                        <select class="form-control" placeholder="Select type" v-model.trim="$v.formProfile.settlementType.$model"  :class="{'is-invalid':$v.formProfile.settlementType.$error}">
                            <option value="" selected>- choose settlement type -</option>
                            <!-- <option value="fixed">Fixed</option> -->
                            <option value="percent">Percentage</option>
                        </select>
                    </div>

                    <div class="row form-group mb-5 px-2">
                        <label><span class="text-danger">*</span>Settlement Value</label>
                        <input class="form-control " type="number" min="0" placeholder="12" v-model.trim="$v.formProfile.settlementValue.$model"  :class="{'is-invalid':$v.formProfile.settlementValue.$error}">
                    </div>
                
                    <div class="row justify-content-between mb-3 px-2 mt-4">
                        <div>
                            <button class="btn btn-danger btn-sm px-5" type="submit" @click.prevent="cancelUpdate()"> Cancel </button>
                            
                        </div>
                        <div>
                            <button v-if="!sending" class="btn btn-primary btn-sm px-5" type="submit" @click.prevent="updateIncomeProfile()"> Update Income Profile </button>
                            
                            <button v-else class="btn btn-primary btn-sm w-100" disabled type="submit" > Update Income Profile </button>
                        </div>
                    </div>
                </form>

                <!-- Beneficiary profiles table -->
                <div class="col-md-7 pl-5">
                    <h6 class="font-weight-bold">LIST OF BENEFICIARY'S INCOME PROFILE</h6>
            
                    <vue-bootstrap4-table 
                        :rows="rows"
                        :columns="columns"
                        :config="config">

                        <template slot="id" slot-scope="props">
                            <span>
                                {{props.row.vbt_id}}
                            </span>
                        </template>

                        <template slot="stateCode" slot-scope="props">
                            <span>
                                {{getStateName(props.cell_value)}}
                            </span>
                        </template>

                        <template slot="settlementType" slot-scope="props">
                            <span v-if="props.cell_value == 'fixed'">
                                Fixed
                            </span>
                            <span v-if="props.cell_value == 'percent'">
                                Percentage
                            </span>
                        </template>

                        <template slot="action" slot-scope="props">
                            <button type="button" @click="editIncomeProfile(props.cell_value)" title="edit income profile" class="btn btn-primary btn-sm">
                                Edit
                            </button>       
                        </template>

                        <template slot="sort-asc-icon">
                            <i class="fas fa-sort-up"></i>
                        </template>
                        <template slot="sort-desc-icon">
                            <i class="fas fa-sort-down"></i>
                        </template>
                        <template slot="no-sort-icon">
                            <i class="fas fa-sort"></i>
                        </template>
                    </vue-bootstrap4-table>
                </div>
            </section>

            <!-- Modal's section -->
            <section>
                <modal name="create-profile-income" class="mt-2" :height="'auto'">
                    <div class="p-3">
                        <h6>You are about to create {{(setupArray.length > 1)?'these':'this'}} {{setupArray.length}} Income profile{{(setupArray.length > 1)?'s':''}}</h6> 
                    </div>
                    <vue-bootstrap4-table 
                        :rows="setupArray"
                        :columns="createColumn"
                        class="col-md-12"
                        style="max-height: 500px; overflow-y: scroll;"
                        :config="createConfig">

                        <template slot="id" slot-scope="props">
                            <span>
                                {{props.row.vbt_id}}
                            </span>
                        </template>

                        <template slot="settlementType" slot-scope="props">
                            <span v-if="props.cell_value == 'fixed'">
                                Fixed
                            </span>
                            <span v-if="props.cell_value == 'percent'">
                                Percentage
                            </span>
                        </template>
                    </vue-bootstrap4-table>

                    <div class="row justify-content-end mr-4 pb-3">
                        <button class="btn btn-danger btn-sm px-5 mr-5" @click="$modal.hide('create-profile-income')">Cancel</button>

                        <button class="btn btn-primary btn-sm px-5" @click.prevent="createIncomeProfile()">Create</button>
                    </div>
                </modal>

                <modal name="failed-data" class="mt-2" :height="'auto'">
                    <div class="p-3">
                        <h6 class="text-danger font-weight-bold">Income Profiles that already exist and not created again</h6> 
                    </div>
                    <vue-bootstrap4-table 
                        :rows="failedData"
                        :columns="createColumn"
                        class="col-md-12"
                        style="max-height: 500px; overflow-y: scroll;"
                        :config="createConfig">

                        <template slot="id" slot-scope="props">
                            <span>
                                {{props.row.vbt_id}}
                            </span>
                        </template>

                        <template slot="settlementType" slot-scope="props">
                            <span v-if="props.cell_value == 'fixed'">
                                Fixed
                            </span>
                            <span v-if="props.cell_value == 'percent'">
                                Percentage
                            </span>
                        </template>
                    </vue-bootstrap4-table>

                    <div class="row justify-content-end mr-4 pb-3">
                        <button class="btn btn-danger btn-sm px-5" @click="$modal.hide('failed-data')">Close</button>
                    </div>
                </modal>
            </section>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { required, email, minLength } from 'vuelidate/lib/validators';
import VueBootstrap4Table from 'vue-bootstrap4-table';

export default {
    name: "ViewProfiles",
    components: {
        VueBootstrap4Table,
    },
    data(){
        return {
            sending: false,
            updating: true,
            // accountEdited: false,
            createIncome: true,
            showNextForms: false,
            statesHolder: [],
            setupArray: [],
            itemHolder:null,
            enrolledStates: [],
            rows: [],
            columns: [
                {
                    label: "S/N",
                    name: "id",
                    slot_name: "id"
                },
                {
                    label: "Item",
                    name: "unitName",
                    slot_name: "itemCode",
                    sort: true,
                },
                {
                    label: "State",
                    name: "stateKey",
                    slot_name: "stateCode",
                    sort: true,
                },
                {
                    label: "Settlement Type",
                    name: "unitType",
                    slot_name: "settlementType",
                    sort: true,
                },
                {
                    label: "Settlement Value",
                    name: "unitValue",
                    slot_name: "settlementValue",
                    sort: true,
                },
                {
                    label: "Action",
                    name: "__id",
                    slot_name: "action"
                },
            ],
            config: {
                card_mode: false,
                checkbox_rows: false,
                rows_selectable: false,
                show_refresh_button: false,
                show_reset_button: false,
                global_search: {
                    placeholder: "Search",
                    visibility: true,
                    case_sensitive: false,
                },
            },
            createColumn: [
                {
                    label: "S/N",
                    name: "id",
                    slot_name: "id"
                },
                {
                    label: "Item",
                    name: "itemName",
                },
                {
                    label: "State",
                    name: "stateName",
                },
                {
                    label: "Settlement Type",
                    name: "settlementType",
                    slot_name: "settlementType",
                },
                {
                    label: "Settlement Value",
                    name: "settlementValue",
                    slot_name: "settlementValue",
                },
            ],
            createConfig: {
                card_mode: false,
                checkbox_rows: false,
                rows_selectable: false,
                show_refresh_button: false,
                show_reset_button: false,
                global_search: {
                    placeholder: "Search",
                    visibility: false,
                    case_sensitive: false,
                },
            },
            beneficiaryId: null,
            incProfileId: null,
            formProfile:{
                stateCode: "",
                itemCode: "",
                settlementType: "",
                settlementValue: "",
            },
            formAccount:{
               name: null,
               email: null,
               phone: null, 
               accountStatus: 0, 
            },
            failedData: []
        }
    },
    
    validations: {
        formProfile:{
            stateCode: {required},
            itemCode: {required},
            settlementType: {required},
            settlementValue: {required},
        },
        formAccount:{
            name: {required},
            accountStatus: {required},
            email: {required, email},
            phone: {required, minLength: minLength(9)}, 
        },
    },

    computed: {
        ...mapState(['token']),
        ...mapGetters(['everyItems']),
    },

    mounted(){
        if (!this.$route.params.id || this.$route.params.id == 'undefined') {
            this.$router.push({path: '/listbeneficiary'});
            this.$toastr.e("No Beneficiary ID provided", "Error Message")
            return;
        }

        this.beneficiaryId = this.$route.params.id;

        // get beneficiary details
        const baseU = `${this.$urlAuth}/beneficiary/${this.beneficiaryId}`;
        this.$http.get(baseU,{
            headers:{
                "x-access-token":this.token
            }
        })
        .then(response => {
            if(response.data.data.code =='S200'){
                this.formAccount.name = response.data.data.beneficiary.name;
                this.formAccount.email = response.data.data.beneficiary.email;
                this.formAccount.phone = response.data.data.beneficiary.phone;
                this.formAccount.accountStatus = response.data.data.beneficiary.accountStatus;

                this.rows = response.data.data.incomeProfile;
            }else{
                this.$toastr.e(response.data.data.message);
            }
        })
        .catch(err => {
            console.log(err);
            if(err.message == "Network Error"){
                this.$toastr.e("Network Error, check internet connection");
                return;
            }
            this.$toastr.e("Internal Server error");
        })

        /**
         * Get all states Enrolled
         */
        const stateUrl = `${this.$urlUpload}/statesenrolled`;
        this.$http.get(stateUrl)
        .then(result => {
            if (result.data.data.code == "S200") {
               this.enrolledStates = result.data.data.message
            }
        })
        .catch(err => console.log(err))
    },

    methods: {
        getStateName(stateCode){
            const state = this.enrolledStates.find(state => stateCode == state.stateCode);
            return (state)? state.stateName : null;
        },

        updateAccount(){
            // Only send after validations
            this.$v.formAccount.$touch()
            if (this.$v.formAccount.$invalid || this.$v.formAccount.$error) {
                this.$toastr.e("Fill in the forms correctly");
            } else {
                const setU = `${this.$urlAuth}/beneficiary/update`;
                this.$http.post(setU, {
                    beneficiaryId: this.beneficiaryId,
                    ...this.formAccount
                    }, {
                    headers:{
                        "x-access-token":this.token
                    }
                })
                .then(response => {
                    if(response.data.data.code =='S200'){
                        this.$toastr.s(response.data.data.message);
                    }else{
                        this.$toastr.e(response.data.data.message);
                    }
                })
                .catch(err => {
                    console.log(err);
                    if(err.message == "Network Error"){
                        this.$toastr.e("Network Error, check internet connection");
                        return;
                    }
                    this.$toastr.e("Internal Server error");
                })
            }
        },

        nextSetProfile(){
            this.showNextForms = true;
            this.setupArray = this.statesHolder.map(state => {
                return {
                    stateCode: state.stateCode,
                    beneficiaryId: this.beneficiaryId,
                    stateName: state.stateName,
                    itemCode: this.itemHolder.itemCode,
                    itemName: this.itemHolder.itemName,
                    settlementType: "percent",
                    settlementValue: null,
                }
            });
        },

        showCreateModal(){
            // make sure nothing is empty
            let typeEmpty = this.setupArray.findIndex(arr => arr.settlementType == "");
            let valueEmpty = this.setupArray.findIndex(arr => arr.settlementValue == null);

            if(typeEmpty >= 0 || valueEmpty >= 0){
                this.$toastr.e("Fill all fields appropratiately", "Error Message");
                return;
            }

            this.$modal.show('create-profile-income');
        },

        createIncomeProfile(){
            this.sending = true;
            const setU = `${this.$urlAuth}/set/beneficiary`;
            this.$http.post(setU, {
                    data: this.setupArray,
                },{
                headers:{
                    "x-access-token":this.token
                }
            })
            .then(response => {
                this.sending = false;
                if(response.data.data.code == 'S200'){
                    // update the income profile table
                    this.rows.push(...response.data.data.goodData);
                    let message = "";

                    if(response.data.data.goodData.length){
                        message += `${response.data.data.goodData.length} Income profiles was created. ` 
                    }

                    if(response.data.data.failedData.length){
                        message += `${response.data.data.failedData.length} Income profiles existed already and not created again.` 

                        this.failedData = response.data.data.failedData;
                        this.$modal.show('failed-data');
                    }

                    this.$modal.hide('create-profile-income');
                    
                    this.$toastr.i(message, "Income Profile Report");
                    this.showNextForms = false;
                    this.statesHolder = [];
                    this.itemHolder = null;
                }else{
                    this.$toastr.e(response.data.data.message);
                }
            })
            .catch(err => {
                this.sending = false;
                console.log(err);
                if(err.message == "Network Error"){
                    this.$toastr.e("Network Error, check internet connection");
                    return;
                }
                this.$toastr.e("Internal Server error");
            })
        },

        editIncomeProfile(incProfileId){
            this.incProfileId = incProfileId;
            const incomeProfile = this.rows.find(row => row.__id == incProfileId);

            this.formProfile.stateCode = this.getStateName(incomeProfile.stateKey) || 'Nil';
            this.formProfile.itemCode = incomeProfile.unitName;
            this.formProfile.settlementType = incomeProfile.unitType;
            this.formProfile.settlementValue = incomeProfile.unitValue;

            this.createIncome = false;
        },

        cancelUpdate(){
            this.createIncome = true;
        },

        updateIncomeProfile(){
            this.sending = true;
            // Only send after validations
            const setU = `${this.$urlAuth}/update/incomeProfile`;
            this.$http.post(setU, {
                    settlementType: this.formProfile.settlementType,
                    settlementValue: this.formProfile.settlementValue,
                    _id: this.incProfileId
                }, {
                headers:{
                    "x-access-token":this.token
                }
            })
            .then(response => {
                this.sending = false;
                if(response.data.data.code =='S200'){
                    this.$toastr.s(response.data.data.message);

                    for (let i = 0; i < this.rows.length; i++) {
                        const row = this.rows[i];
                        if(row.__id == this.incProfileId){
                            this.rows[i].unitType = this.formProfile.settlementType
                            this.rows[i].unitValue = this.formProfile.settlementValue

                            break;
                        }
                    }
                    this.createIncome = true;
                }else{
                    this.$toastr.e(response.data.data.message);
                }
            })
            .catch(err => {
                this.sending = false;
                console.log(err);
                if(err.message == "Network Error"){
                    this.$toastr.e("Network Error, check internet connection");
                    return;
                }
                this.$toastr.e("Internal Server error");
            })
            
        },
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>